import { mergeStyles } from '@fluentui/react';
import * as React from 'react';
import { getCommonClassNames, getCommonStyles } from '../styles/commonStyles';
import { IGroupmeBrandedHeaderStyles, getGroupmeBrandedHeaderClassNames } from '../styles/groupmeBrandedHeaderStyles';
import { IStyledComponent } from '../styles/themesUI';
import { getString } from '../../../../web/utils/stringLoader';

type IGroupMeBrandedHeaderProps = IStyledComponent<IGroupmeBrandedHeaderStyles>;

const commonClassNames = getCommonClassNames(getCommonStyles!, {});

export const GroupmeBrandedHeader: React.FC<IGroupMeBrandedHeaderProps> = (props) => {
    const headerClassNames = getGroupmeBrandedHeaderClassNames(props.styles, { theme: props.theme });
    return (
        <div className={mergeStyles(headerClassNames.brandedHeader, headerClassNames.groupmeBrand)} id="groupMeBrandedHeader" >
            <div className= {commonClassNames.containerFluid} >
                <div className={headerClassNames.row}>
                <div className={mergeStyles(commonClassNames.colLgThree, commonClassNames.colXsZero)} />
                    <div className={mergeStyles(commonClassNames.colLgSeven, commonClassNames.colXsTwelve)} >
                        <h1 tabIndex={-1} className={headerClassNames.headerBrand} id="groupMeBrandedHeaderBrand">{getString('search_groupmeBrandingHeaderText')}</h1>
                        <h2 tabIndex={-1} className={headerClassNames.headerText} id="groupMeBrandedHeaderText">{getString('search_groupmeHeaderText')}</h2>
                        <p className={mergeStyles(commonClassNames.textNormal, headerClassNames.subHeaderText)} id="groupMeBrandedSubHeaderText">{getString('search_groupmeSubHeaderText')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
